/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import React from 'react';
import HamburgerSVG from '../../public/assets/icons/hamburger.svg';

const AmpHamburger = () => (
  <div role="button" aria-label="Open main menu" on="tap:sidebar1.toggle" tabIndex="0" className="hamburger">
    <HamburgerSVG />
  </div>
);

export default AmpHamburger;
